import { render } from "./SurveyOrgRanking.vue?vue&type=template&id=24ebf857&scoped=true"
import script from "./SurveyOrgRanking.vue?vue&type=script&lang=ts"
export * from "./SurveyOrgRanking.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-24ebf857"

export default script